import { ExchangeType } from "src/Interfaces/connections";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";

export const exchangeTypeOptions: DropdownItem[] = [
  { id: "", name: "همه" },
  { id: ExchangeType.StockExchange, name: "بورس اوراق" },
  { id: ExchangeType.CommodityExchange, name: "بورس کالا" },
];

export const portfolioGroupExchangeTypeOptions: DropdownItem[] = [
  { id: ExchangeType.StockExchange, name: "اوراق بهادار" },
  { id: ExchangeType.CommodityExchange, name: "کالا" },
];
